module.exports = __webpack_public_path__ + "static/restaurant-cleaning-checklist-43e8f25c6e9f2a76f047b22cd6bc7b80.jpeg";